import React from 'react';
import YouTube from 'react-youtube';
import _ from 'lodash';
import {
	flexDirection
} from '../../style/Global';

// BUFFERING: 3
// ​
// CUED: 5
// ​
// ENDED: 0
// ​
// PAUSED: 2
// ​
// PLAYING: 1
// ​
// UNSTARTED: -1
class YoutubeSinglePlay extends React.Component {
	constructor(props){
		super(props);

		const { musicVideo } = props;
		const height = this.props.height ? this.props.height : 245;
		const width = this.props.width ? this.props.width : 320;

		this.state ={
			musicVideo,
			ytt:'',
			opts: {
				height,
				width,
				playerVars: { // https://developers.google.com/youtube/player_parameters
					autoplay: 0
				},
				loop:1
			},
			playerState:-100
		}

		
	

	// console.log('reload youtube', musicVideo);
	// console.log('youtube states', YouTube.PlayerState );
	}

	componentDidUpdate(prevProps) {
		const {
			musicVideo
		} = this.props;
		const {
			musicVideo:stateMusicVideo,
			ytt
		} = this.state;
		// const {
		// 	ytt
		// } = this.state;
		// console.log('musicv', musicVideo);
		if(prevProps.musicVideo !== musicVideo) {
		  this.setState({musicVideo});
		}
	  }

	

	onPause = (event) => {
		
		this.setState((prevState) => ({
			...prevState,
			ytt: _.assign({}, event),
			playerState:event.target.getPlayerState()
		}));
		event.target.pauseVideo();
	};


	onStateChange = (event) => {
		this.setState((prevState) => ({
			...prevState,
			ytt: _.assign({}, event),
			playerState:event.target.getPlayerState()
		}));

		const {playAutomatically} = this.props;
		const youtubePlayerState = event.target.getPlayerState();
		// console.log('evv', youtubePlayerState);
		// console.log('state change');
		// event.target.playVideo();
		if (youtubePlayerState === 5){
			// console.log('play true', event.target);
			event.target.playVideo();
		}
		
	};

	load = (event) => {
		event.target.playVideo();
		this.setState((prevState) => ({
			...prevState,
			ytt: _.assign({}, event),
			playerState:event.target.getPlayerState()
		}));
		// console.log('youtube ready');
		// event.target.pauseVideo();
	};

	controlYT = () => {
		

		const {ytt} = this.state;
		const youtubePlayerState = ytt.target.getPlayerState();

		if (youtubePlayerState === 1){
			ytt.target.pauseVideo();
		}
		else if (youtubePlayerState === 2 || youtubePlayerState === 5){
			ytt.target.playVideo();
		}
	};

	onEnd = (event) => {
		const {onSongEnd} = this.props;
		// onSongEnd();

		// ytt = _.assign({}, event);
		// console.log('end', ytt);
	};

	render(){
		const {
			musicVideo,
			opts,
			ytt,
			playerState
		} =this.state;

		// console.log('state player st', playerState);
		
		return (
		
			<div style={{...flexDirection.column, display:'none'}}>
			<YouTube
				title={musicVideo}
				opts={opts}
				videoId={musicVideo}
				// onEnd={this.onEnd} 
				onPause={this.onPause}
				onReady={this.load}
				onStateChange={this.onStateChange}
			/>
			{/* <PlayerControlContainerCentered
				className='ref-player-icon'
			
			>
				<div onClick={this.controlYT}>
					{
						playerState === -100 ||
						playerState === 2 ||
						playerState === 5 ?
						<FaPlay
							size={50}
						/>
						:
						<FaPause
						size={50}
					/>
					}
					
				</div>
			</PlayerControlContainerCentered> */}
			</div>
		);
	}
	

};

export default YoutubeSinglePlay;